import { render, staticRenderFns } from "./UiHeader.vue?vue&type=template&id=282fb390&scoped=true"
import script from "./UiHeader.vue?vue&type=script&lang=js"
export * from "./UiHeader.vue?vue&type=script&lang=js"
import style0 from "./UiHeader.vue?vue&type=style&index=0&id=282fb390&prod&scoped=true&lang=css"
import style1 from "./UiHeader.vue?vue&type=style&index=1&id=282fb390&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fb390",
  null
  
)

export default component.exports